import { UseQueryOptions, useQuery } from '@tanstack/react-query';

import { ReferralShareLinkResponse } from './useReferralShareLink.interface';
import fetchReferralShareLink from './useReferralShareLink.request';

import { getReferralCopyUrl } from 'services/member/fetchReferralShareLink';

const useReferralShareLink = (options?: Omit<UseQueryOptions<ReferralShareLinkResponse>, 'queryKey' | 'queryFn'>) => {
    const query = useQuery<ReferralShareLinkResponse>({
        queryKey: ['member', 'referralShareLink'],
        queryFn: fetchReferralShareLink,
        staleTime: 60_000,
        ...options,
    });

    const copyUrl = getReferralCopyUrl(query.data ?? { share_link: null, referral_code: null });
    const referralCode = query.data?.referral_code ?? null;

    return { ...query, copyUrl, referralCode };
};

export default useReferralShareLink;
